import {TypeOfWorkCategory} from "./constants";
import TemplateView from "../TemplateView";
import {typeOfWorkComparator} from "./utils";

export default class TypesOfWorkList extends TemplateView {
    constructor({
        categoryRenderer = null,
        nodeRenderer = null,
    }) {
        super()

        this.state = {
            typesOfWork: []
        }

        this.params = {
            categoryRenderer,
            nodeRenderer,
        }

        this.onStatePropertyDeeplyChanged('typesOfWork', () => {
            this._renderTypesOfWork()
        })
    }

    templateHtml() {
        return '<div class="typeOfWorkList">' +
               '</div>'
    }

    _renderTypesOfWork() {
        this.$el.empty()

        const nonBillable = []
        const billable = []

        this.state.typesOfWork.sort(typeOfWorkComparator).forEach(type => {
            if (type.billable === false) {
                nonBillable.push(type)
            } else {
                billable.push(type)
            }
        })


        this.params.categoryRenderer(this.$el, TypeOfWorkCategory.NON_BILLABLE)

        nonBillable.forEach(typeOfWork => {
            this.params.nodeRenderer(this.$el, typeOfWork)
        })

        if (billable.length !== 0) {
            this.params.categoryRenderer(this.$el, TypeOfWorkCategory.BILLABLE)

            billable.forEach(typeOfWork => {
                this.params.nodeRenderer(this.$el, typeOfWork)
            })
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypesOfWorkList.js